import { firestore } from "../firebase";
const state = {
  notificacion: [],
};
const mutations = {
  guardarNotificaciones(state, notificaciones) {
    state.notificacion = notificaciones;
  },

};
const actions = {
 
  limpiarStore({ commit }) {
    commit("guardarNotificaciones", null);
  },

  async obtenerNotificaciones({ commit, rootState }) {
    const notificaciones = [];
    const uidUser = rootState.autenticacion.usuario.uid;
    const proyectosfirestore = await firestore
      .collection("usuarios")
      .doc(uidUser)
      .collection("notificaciones")
      .get();
    proyectosfirestore.docs.forEach((doc) => {
      const noti = doc.data();
      noti.id = doc.id;
      notificaciones.push(noti);
    });

    commit("guardarNotificaciones", notificaciones);
  },

  async borrarNotificaciones({ commit, rootState },{idNotificacion}) {
    const uidUser = rootState.autenticacion.usuario.uid;
     await firestore
      .collection("usuarios")
      .doc(uidUser)
      .collection("notificaciones")
      .doc(idNotificacion)
      .delete();
      await this.obtenerNotificaciones()
  },



}

const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
